import { Highlight, NavigationLink } from '@domgen/dgx-fe-common';
import { Content } from '@domgen/dgx-fe-components/content';

export interface ErrorPageContentBlock extends Content {
  highlight?: Highlight;
  link?: NavigationLink;
  subtitle?: string;
}
